import { useState } from "react";
import { useIdleTimer } from "react-idle-timer";

interface IdleTimeoutOptions {
  idleTime?: number;
  onTimeout: () => void;
}

const useIdleTimeout = ({ idleTime = 900, onTimeout }: IdleTimeoutOptions) => {
  const idleTimeout = 1000 * idleTime;
  const [isIdle, setIdle] = useState(false);

  const handleIdle = () => {
    setIdle(true);
    onTimeout();
  };

  const idleTimer = useIdleTimer({
    timeout: idleTimeout,
    onIdle: handleIdle,
    debounce: 500,
    crossTab: true,
    syncTimers: 3000
  });

  return {
    isIdle,
    setIdle,
    idleTimer,
  };
};

export default useIdleTimeout;
